import React, { useContext } from 'react'
import styles from '../../styles/Layout.module.css'
import { AuthContext } from '../../store/auth-context'
import { Outlet } from 'react-router-dom'
import AgentNavigation from './AgentNavigation'


const AgentLayout = (props: any) => {

    const authCtx = useContext(AuthContext)

    return (
        <>
            
            { authCtx.isLoggedIn && <AgentNavigation /> }
            <main className={`${styles.mainContainer}`}>
                <Outlet />
            </main>
        </>
    )
}

export default AgentLayout
